<template>
  <v-container>
    <h1>Theme: {{themeName}}</h1>

    <v-card
      class="my-4"
      :style="themeCssVariables"
      :light="!darkMode"
    >
      <v-card-title>
        <h3 class="headline">Theme Preview</h3>
        <v-spacer />
        <v-switch v-model="darkMode" label="Dark Mode" />
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h4>Buttons</h4>
            <div class="my-2"><v-btn>Normal</v-btn></div>
            <div class="my-2"><v-btn color="primary">Primary</v-btn></div>
            <div class="my-2"><v-btn color="secondary">Secondary</v-btn></div>
            <div class="my-2"><v-btn color="info">Info</v-btn></div>
            <div class="my-2"><v-btn color="success">Success</v-btn></div>
            <div class="my-2"><v-btn color="warning">Warning</v-btn></div>
            <div class="my-2"><v-btn color="error">Error</v-btn></div>
          </v-col>
          <v-col>
            <h4>Alerts</h4>
            <v-alert type="primary">Primary</v-alert>
            <v-alert type="secondary">Secondary</v-alert>
            <v-alert type="accent">Accent</v-alert>
            <v-alert type="info">Info</v-alert>
            <v-alert type="success">Success</v-alert>
            <v-alert type="warning">Warning</v-alert>
            <v-alert type="error">Error</v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>
        <h3>Theme Definition</h3>
      </v-card-title>
      <v-card-text>
        <markdown
          :key="themeName"
          :source="themeMarkdown"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import * as Themes from '@resman/ui/themes';
import Markdown from '@/components/Markdown';

export default {
  name: 'Theme',
  components: {Markdown},
  props: {
    themeName: String,
  },
  data() {
    return {
      darkMode: false,
      themeCssVariables: {},
    };
  },
  watch: {
    theme: {
      immediate: true,
      handler(theme) {
        this.$vuetify.theme.themes.light = theme.vuetifyTheme;
        this.$vuetify.theme.dark = false;
        this.themeCssVariables = this.getCurrentCssVariables();
        this.$vuetify.theme.dark = true;
      }
    },
  },
  computed: {
    themeMarkdown() {
      return '```json5\n' + JSON.stringify(this.theme, null, 2) + '\n```';
    },
    theme() {
      return Themes[this.themeName].default;
    },
  },
  methods: {
    getCurrentCssVariables() {
      const vuetifyStyleSheet = Array.from(document.styleSheets).find(({ownerNode}) => ownerNode.id === 'vuetify-theme-stylesheet');
      const rootRule = Array.from(vuetifyStyleSheet.cssRules).find(({selectorText}) => selectorText === ':root');
      const matches = Array.from(rootRule.cssText.matchAll(/(--v-[a-z0-9\-]+): (#[0-9a-f]+);/g));

      const cssVars = {};

      matches.forEach(([_, variable, color]) => cssVars[variable] = color);

      return cssVars;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
